import { BraintreeService } from './BraintreeService';
import { Client, PayPalCheckout } from 'braintree-web';

let sdkResult: Promise<PayPalCheckout> | null = null;

/**
 * Gets an instance of the PayPal SDK. Caches the result, so subsequent calls will not trigger
 * more requests to load the SDK.
 *
 * @param [braintreeBaseUrl=""] baseUrl passed to {@link BraintreeService}'s constructor.
 * Defaults to empty string, meaning that the service will use relative URLs. See `BrainTreePayPalController`
 * for handled endpoints. NOTE: because the instance is "cached", it is currently not supported to instantiate
 * multiple instances with different brainTreeBaseUrls.
 *
 * @returns A Promise holding a PayPalCheckout
 */
export function getPayPalSDK(braintreeBaseUrl: string = ""): Promise<PayPalCheckout> {
	if (sdkResult) {
		return sdkResult;
	}

	// @ts-ignore
	if (window.publicPath) __webpack_public_path__ = window.publicPath;

	async function get() {
		try {
			const braintreeService = new BraintreeService(braintreeBaseUrl);
			const [token, BTPClient, paypalCheckout] = await Promise.all([
				braintreeService.getToken(),
				// braintree-web is quite large and is not tree-shakeable. We can import just the pieces
				// we need to make it smaller and do so dynamically to incur the costs only when necessary
				// and avoid bloating bundles
				import(/* webpackChunkName: "braintree-client" */ 'braintree-web/client') as Promise<Client>,
				import(/* webpackChunkName: "bt-paypal-checkout" */ 'braintree-web/paypal-checkout') as Promise<PayPalCheckout>,
			]);
			const client = await BTPClient.create({ authorization: token });
			const sdk = await paypalCheckout.create({ client });
			await sdk.loadPayPalSDK({
				components: 'buttons,messages',
				intent: 'authorize',
				currency: 'USD',
				'enable-funding': 'paylater',
				commit: false,
			});
			return sdk;
		} catch (e) {
			return null;
		}
	}

	sdkResult = get();
	return sdkResult;
}